export class DateUtils {
  static getTimezone() {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  }
}
